import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import {
	CheckOverridesRequest,
	CheckOverridesResponse,
	CheckSensorDeletionsResponse,
	CreateValuemappingProfileRequest,
	DurationDialogOperation,
	GetValuemappingProfilesParams,
	GetValuemappingProfilesRequest,
	GetValuemappingProfilesResponse,
	UpdateValuemappingProfileRequest,
	ValuemappingProfileCheckSensorDeletionsActionPayload,
} from '@Types/valuemappingManager.types';
import { MultiselectOption } from '@Types/multiselect.types';
import { ValuemappingProfileFormShape } from '@Types/valuemappingForm.types';

export const getValueMappingProfiles =
	createAction<GetValuemappingProfilesParams>(
		addNamespace('valueMapping/getProfiles'),
	);
export const getValueMappingProfilesResolved =
	createAction<GetValuemappingProfilesResponse>(
		addNamespace('valueMapping/getProfiles/resolved'),
	);
export const getValueMappingProfilesRejected = createAction(
	addNamespace('valueMapping/getProfiles/rejected'),
);

export const getSingleValueMappingProfile = createAction<string>(
	addNamespace('valueMapping/getSingleProfile'),
);
export const getSingleValueMappingProfileResolved =
	createAction<ValuemappingProfileFormShape>(
		addNamespace('valueMapping/getSingleProfile/resolved'),
	);
export const getSingleValueMappingProfileRejected = createAction(
	addNamespace('valueMapping/getSingleProfile/rejected'),
);

export const checkOverridesValueMappingProfile =
	createAction<CheckOverridesRequest>(
		addNamespace('valueMapping/checkOverridesProfile'),
	);
export const checkOverridesValueMappingProfilesResolved = createAction<
	CheckOverridesResponse['rows']
>(addNamespace('valueMapping/checkOverridesProfile/resolved'));
export const checkOverridesValueMappingProfilesRejected = createAction(
	addNamespace('valueMapping/checkOverridesProfile/rejected'),
);

export const createValueMappingProfile =
	createAction<CreateValuemappingProfileRequest>(
		addNamespace('valueMapping/createProfile'),
	);
export const createValueMappingProfilesResolved = createAction<unknown>(
	addNamespace('valueMapping/createProfile/resolved'),
);
export const createValueMappingProfilesRejected = createAction(
	addNamespace('valueMapping/createProfile/rejected'),
);

export const updateValueMappingProfile =
	createAction<UpdateValuemappingProfileRequest>(
		addNamespace('valueMapping/updateProfile'),
	);
export const updateValueMappingProfileResolved =
	createAction<ValuemappingProfileFormShape>(
		addNamespace('valueMapping/updateProfile/resolved'),
	);
export const updateValueMappingProfileRejected = createAction(
	addNamespace('valueMapping/updateProfile/rejected'),
);

export const deleteValuemappingProfile = createAction<string>(
	addNamespace('valueMapping/deleteProfile'),
);
export const deleteValuemappingProfileResolved = createAction<string>(
	addNamespace('valueMapping/deleteProfile/resolved'),
);
export const deleteValuemappingProfileRejected = createAction(
	addNamespace('valueMapping/deleteProfile/rejected'),
);

export const changeValueMappingTableProfilesFilter = createAction<{
	name: string;
	value: string;
}>(addNamespace('valueMapping/table/profiles/filter'));
export const changeValueMappingTableProfilesSort = createAction<
	GetValuemappingProfilesRequest['sort']
>(addNamespace('valueMapping/table/profiles/sort'));
export const changeValueMappingTableProfilesPageSize = createAction<number>(
	addNamespace('valueMapping/table/profiles/pageSize'),
);

export const getValuemappingSensorsList = createAction(
	addNamespace('valueMapping/getSensors'),
);
export const getValuemappingSensorsListResolved = createAction<
	MultiselectOption[]
>(addNamespace('valueMapping/getSensors/resolved'));
export const getValuemappingSensorsListRejected = createAction(
	addNamespace('valueMapping/getSensors/rejected'),
);

export const checkSensorDeletionsValueMappingProfile =
	createAction<ValuemappingProfileCheckSensorDeletionsActionPayload>(
		addNamespace('valueMapping/checkSensorDeletions'),
	);
export const checkSensorDeletionsValueMappingProfilesResolved =
	createAction<CheckSensorDeletionsResponse>(
		addNamespace('valueMapping/checkSensorDeletions/resolved'),
	);
export const checkSensorDeletionsValueMappingProfilesRejected = createAction(
	addNamespace('valueMapping/checkSensorDeletions/rejected'),
);

export const setValuemappingProfileDurationDialogOpen =
	createAction<DurationDialogOperation>(
		addNamespace('valueMapping/durationDialogOpen'),
	);
